<template>
    <div class='top-section' v-if="user">
        <div class="flex justify-center ph-20">
            <div class="breadcrumbs mt-20 w-full " >
                <router-link to="/admin/users/" class="main-item">
                    Clients
                </router-link>
                <img src="@/assets/arrow-opener.svg" alt="arrow-right"  class="p-10" />
                <div class="last-item" >
                    <div>{{user?.user?.username}}</div> 
                </div>
            </div>
        </div>

        <div class='font-size-24 w-full text-left bold ph-20 flex space-between'>
            <div>{{user?.user?.username}} {{user?.user?.email}} <span style="font-size: 14px">(account_id: {{ user?.user?.account_id }})</span></div> 
            <div class="buttons flex gap-10">
                <button class="button w-content" @click="generalSettings()">Settings</button>
                <button class="button w-content" @click="createInvoice()">Create Invoice</button>
            </div>
        </div>
        <div class="p-20 border-box" style="max-width: 640px" v-if="clientPendingAgreement">
            <div class="text-left bold font-size-20 mb-10 mt-20">Pending Agreement: </div>
            <div class="pending-agreement flex justify-between align-center">
                <div class='attachment  grayed w-full border-box' style="max-width: 400px;">
                    <img src="@/assets/pdf-file.svg" class='fileicon pl-5'>
                    <div class="filename">
                        <div class="name-of-the-file">{{ clientPendingAgreement.user_filename }}</div>
                        <div class="size-of-the-file">{{ Utils.calculateFileSize(clientPendingAgreement.user_filesize) }}</div>
                    </div>
                    <div class="flex-1 flex justify-end p-10 pointer">
                        <img class='download' @click="downloadAgreement()" src="@/assets/download.svg"> 
                    </div>
                </div>
                <div class="buttons flex row gap-10">
                    <button class='w-content transparent' @click="() => pendingAgreementPopup = 'rejected'">Reject</button>
                    <button class='w-content' @click="() => pendingAgreementPopup = 'approved_and_signed'">Accept</button>
                </div>
            </div>
        </div>
        <Subscriptions class="ph-20"/>
        <UserInfo :account_id="localUser.clientAccount.account_id" class="p-20"/>

        <CompanyUsers :account_id="localUser.clientAccount.account_id" :client_id="props.id"/>

        <UsageFIU :account_id="localUser.clientAccount.account_id"/>
        <InvoicesView :account_id="localUser.clientAccount.account_id"/>

        <FileListView :account_id="localUser.clientAccount.account_id"/>
    

        <Reports :account_id="localUser.clientAccount.account_id"/>

        <AdminTable v-if="user.loginHistory" 
            :data="user.loginHistory" 
            header='Login History' 
            :headers="login_headers"
        ></AdminTable>
   
        <div v-else>
            <div v-if="user == null">
                LOADING DATA
            </div>
            <div v-else>            
                No info
            </div>
        </div>

        <PopupCover v-if="settingsPopup" @close="settingsPopup = null">
            <PopupBody @close="settingsPopup = null">
                <template #header>
                    User Settings
                </template>
                <template #body>
                    <div class="flex column gap-20">
                        <div class="flex column gap-10 w-full">
                            <Toggle
                                :value="clientSettings.is_test"
                                :options="[
                                    { label: 'No', value: false },
                                    { label: 'Yes', value: true },
                                ]"
                                @change="(val) => clientSettings.is_test = val"
                                :label="'is Test Account'"
                            />
                            <Toggle
                                :value="clientSettings.do_max_fiu_rows_check"
                                :options="[
                                    { label: 'Disabled', value: false },
                                    { label: 'Enabled', value: true },
                                ]"
                                @change="(val) => clientSettings.do_max_fiu_rows_check = val"
                                :label="'Max FIU Rows Check'"
                            />
                            <InpComponent
                                v-for="setting in [
                                    'max_fiu_rows_per_month',
                                    'vat_percentage',
                                    'fiu_monthly_price', 'fiu_report_price', 
                                    'kyc_monthly_price', 'sanction_screening_report_price', 
                                    'due_dilligence_monthly_price']" 
                                :noMargin="true"
                                :label="setting.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')"
                                type="number"
                                :value="clientSettings[setting]"
                                @inputChange="(event) => clientSettings[setting] = event[1]"
                            />
                        </div>
                        <div class="flex justify-end gap-10">
                            <button class="button w-content transparent" @click="settingsPopup = null">Close</button>
                            <button class="button w-content" @click="saveSettings()">Save</button>

                        </div>
                    </div>
                </template>
            </PopupBody>

        </PopupCover>

        <PopupCover v-if="invoicePopup" @close="invoicePopup = null">
            <PopupBody @close="invoicePopup = null" style="width: 1020px; max-width: 90vw; margin: auto; max-height: 90vh; overflow: auto;">
                <template #header>
                    Invoice Preview
                </template>
                <template #body>
                    <div class="flex row gap-20">
                        <div class="invoice-inputs flex column gap-20 h-content" style="min-width: 170px;">
                            <div class="bold font-size-20 text-left">
                                Invoice Data
                            </div>
                            <InpComponent 
                                label="Billing Period Start"
                                type="date"
                                key_ref="startDate"
                                :value="invoiceData.startDate"
                                @inputChange="inputChangeFunc"
                                :noMargin="true"
                            />
                            <InpComponent 
                                label="Belling Period End"
                                type="date"
                                key_ref="endDate"
                                :value="invoiceData.endDate"
                                @inputChange="inputChangeFunc"
                                :noMargin="true"
                            />
                            <div class="flex gap-20">
                                <div class="last-month-item" @click="lastMonthApply()">Last Month</div>
                                <div class="last-month-item" @click="thisMonthApply()">This Month</div>
                            </div>
                        </div>
                        <div class="flex column gap-20">
                            <div class="flex flex col gap-10 w-full invoice-preview p-20">
                                <div class='html-preview w-full' v-html="invoicePopup" ></div>
                            </div>
                            <div class="flex justify-end gap-10">
                                <button class="button w-content" @click="confirmCreate()">Create</button>
                            </div>
                        </div>
                    </div>
                </template>
            </PopupBody>
        </PopupCover>
        <PopupCover v-if="confirmSend" @close="confirmSend = null">
            <PopupBody @close="confirmSend = null">
                <template #header>
                    Invoice Creation Confirmation
                </template>
                <template #body>
                    <div class="flex column gap-20">
                    <div class="flex flex col gap-10 w-full">
                        Are you sure you want to create and send this invoice?
                    </div>
                        <div class="flex justify-end gap-10">
                            <button class="button w-content transparent" :disabled='sendingRequest' @click="confirmSend = false">Go back To Edit</button>
                            <button class="button w-content" :disabled='sendingRequest' @click="approveCreate()">Confirm{{sendingRequest ? 'ing': ''}} & Send{{sendingRequest ? 'ing' : ''}}</button>
                        </div>
                    </div>
                </template>
            </PopupBody>
        </PopupCover>
        <PopupCover v-if="pendingAgreementPopup" @close="pendingAgreementPopup = false">
             <PopupBody @close="pendingAgreementPopup = false">
                <template #header>
                    Agreement Status Change Confirmation
                </template>
                <template #body>
                    <div class="flex column gap-20">
                        <div class="flex flex col gap-10 w-full">
                            <text v-if="pendingAgreementPopup == 'rejected'">Are you sure you want to 
                            {{ pendingAgreementPopup }} the agreement?</text>

                            <text v-if="pendingAgreementPopup == 'approved_and_signed'">Are you sure you want to 
                            {{ pendingAgreementPopup }} the agreement and upload the signed file?</text>
                        </div>
                        <div class="flex justify-end gap-10 column">
                            <InpComponent
                                v-if="pendingAgreementPopup == 'rejected'"
                                label="Rejection Reason"
                                style="background-color: white;"
                                :noMargin="true"
                                :value="rejectionReason"
                                @inputChange="rejectionReason = $event[1]"
                            />
                            <MultifileUploader
                                v-if="pendingAgreementPopup == 'approved_and_signed'"
                                type=".pdf" 
                                :single=true 
                                @sendFileInfo="getFiles" 
                                class="uploadfile"/>

                            <div class="flex justify-end gap-10">
                                <button class="button w-content transparent" :disabled='sendingRequest' @click="pendingAgreementPopup = false">Cancel</button>
                                <button class="button w-content" :disabled='sendingRequest' @click="agreementStatusChange()">Confirm</button>
                            </div>
                        </div>
                    </div>
                </template>
            </PopupBody>
        </PopupCover>
       
    </div>
</template>

<script setup>

import dayjs from 'dayjs';


import Subscriptions from './Subscriptions.vue'
import InpComponent from '@/components/InpComponent.vue'
import Toggle from '@/elements/Toggle.vue'
import AdminTable from '@/components/AdminTable.vue'
import Utils from '../utils/index.js'
import BO_API from '../api/bo_api.js' 
import API from '../api/index.js'
import store from '@/store/index.js';
import { ref, onMounted, computed } from 'vue';

import PopupCover from '@/components/PopupCover.vue';
import PopupBody from '@/components/PopupBody.vue';
import UsageFIU from '@/views/UsageFIU.vue'
import FileListView from '@/views/FileListView.vue'
import InvoicesView from '@/views/InvoicesView.vue';
import Reports from '@/views/Reports.vue';
import UserInfo from '@/views/UserInfo.vue'
import CompanyUsers from './CompanyUsers.vue'
import MultifileUploader from '@/components/MultifileUploader.vue';

const options = { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' };
const localUser = computed(() => store.state.adminPannelUser);
const invoicePopup = ref(null);
const settingsPopup = ref(null);
const agreements = computed(() => store.state.pendingAgreements);

const pendingAgreementPopup = ref(false);
const rejectionReason = ref('');
const userInformation = computed(() => store.state.userInformation);
const clientPendingAgreement = computed(() => agreements.value? agreements.value.find(el => el.a_id == localUser.value.clientAccount.account_id) : null)

const selectedFile = ref(false);

const clientSettings = ref({
    is_test: null,
    do_max_fiu_rows_check: null,
    vat_percentage: null,
    max_fiu_rows_per_month: null,
    fiu_monthly_price: null,
    fiu_report_price: null,
    kyc_monthly_price: null,
    sanction_screening_report_price: null,
    due_dilligence_monthly_price: null,
})

const confirmSend = ref(false);
const sendingRequest = ref(false);
const props = defineProps({
    id: String,
})
const user = ref(null);

const login_headers = [
    {"name": 'Date', "key": 'loginDate'},
    {"name": "IP", "key": 'ip'},
    {"name": "userAgent", "key": 'userAgent'},
];

const invoiceData = ref({
    startDate: dayjs().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
    endDate: dayjs().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
})

function inputChangeFunc(event) {
    const event_type = event[0];
    const event_value = event[1];
    invoiceData.value[event_type] = event_value;
    createInvoice();
}
onMounted(async () => {
    await loadUserData(props.id);
})

async function downloadAgreement(){
    await API.downloadAgreementFile(clientPendingAgreement.value._id, clientPendingAgreement.value.user_filename, 'user');
}

function getFiles(files) {
  selectedFile.value = files[0];
}
async function sendAgreementFile(){
  const response = await API.uploadAgreement(selectedFile.value, localUser.value.user.account_id);
  selectedFile.value = null;
  window.location.reload(); // Reload the page to reflect the changes after uploading the agreement
}

function lastMonthApply(){
    invoiceData.value.startDate = dayjs().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
    invoiceData.value.endDate = dayjs().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
    createInvoice();
}
function thisMonthApply() {
    invoiceData.value.startDate = dayjs().startOf('month').format('YYYY-MM-DD');
    const currentDate = dayjs().format('YYYY-MM-DD');
    const calculatedEndDate = dayjs().endOf('month').format('YYYY-MM-DD');
    invoiceData.value.endDate = dayjs(calculatedEndDate).isAfter(currentDate) ? currentDate : calculatedEndDate;
    createInvoice();
}
async function loadUserData(id){
    const data_resp = await API.getUser(id);
    if (data_resp && data_resp.user){
        user.value = data_resp
        store.state.adminPannelUser = data_resp;

        mapVlaues()


    } else {
        user.value = {}
    }
}

async function saveSettings (){
    localUser.value.user.account_id ,localUser.value.clientAccount

    const dataToSend = {
        ...user.value.clientAccount,
        ...clientSettings.value
    }
    const response = await BO_API.updateClientAccount(user.value.user.account_id , dataToSend);
    if (response.status == 'success') {
        store.state.adminPannelUser.clientAccount = response.clientAccount;
        store.dispatch('addNotification', {
            text: 'Subscription updated successfully',
            type: 'success'
        })  
        settingsPopup.value = false;
    } else {
        store.dispatch('addNotification', {
            text: response.error || 'Error updating subscription',
            type: 'error'
        })  
    }
}

function mapVlaues(){
    for(let key in clientSettings.value){
        if (user.value.clientAccount.hasOwnProperty(key)){
            clientSettings.value[key] = user.value.clientAccount[key]
        }
    }
}

async function agreementStatusChange() {
    if (
        pendingAgreementPopup.value == 'rejected'
        && (!rejectionReason.value || rejectionReason.value.trim().length < 10))  
        {
        store.dispatch('addNotification', {
            text: 'Please provide a reason for rejection.',
            type: 'error'
        });
        return;
    }
    if (
        pendingAgreementPopup.value == 'approved_and_signed'
        && !selectedFile.value
    ) {
        store.dispatch('addNotification', {
            text: 'Please attach the signed agreement file.',
            type: 'error'
        });
        return;
    }
    if (
        pendingAgreementPopup.value == 'approved_and_signed'
        && selectedFile.value
    ) {
        await sendAgreementFile();
        return
    }

    const response = await BO_API.updateAgreementStatus({
        account_id: localUser.value.clientAccount.account_id,
        status: pendingAgreementPopup.value,
        reason: rejectionReason.value
    });
    if (response.status == 'success') {
        store.dispatch('addNotification', {
            text: 'Agreement status updated successfully',
            type: 'success'
        });
        pendingAgreementPopup.value = false;
        rejectionReason.value = '';
        await loadUserData(props.id);
    } else {
        store.dispatch('addNotification', {
            text: response.error || 'Error updating agreement status',
            type: 'error'
        });
    }
    
}

async function confirmCreate(){
    confirmSend.value = true; 
}
async function approveCreate(){
    sendingRequest.value = true;
    const resp = await BO_API.createInvoice({
        account_id: localUser.value.clientAccount.account_id,
        preview: false,
        extraData: {
            startDate: invoiceData.value.startDate,
            endDate: invoiceData.value.endDate,
        }
    })
    confirmSend.value = false;
    sendingRequest.value = false;

    if (resp.data.preview.invoiceId) {
        store.dispatch('addNotification', {
            type: 'success',
            text: 'Invoice created and sent successfully.'
        });
        invoicePopup.value = null;
    } else {
        store.dispatch('addNotification', {
            type: 'error',
            text: 'There was an error creating the invoice. Please try again.'
        });
    }
}

async function generalSettings(){
    settingsPopup.value = true;
}

async function createInvoice(){
    if (dayjs(invoiceData.value.startDate).isAfter(dayjs(invoiceData.value.endDate))) {
        store.dispatch('addNotification', {
            type: 'error',
            message: 'Start date cannot be after end date.'
        });
        return;
    }

    const resp = await BO_API.createInvoice({
        account_id: localUser.value.clientAccount.account_id,
        preview: true,
        extraData: {
            startDate: invoiceData.value.startDate,
            endDate: invoiceData.value.endDate,
        }
    })
    invoicePopup.value = resp.data.preview;
}


</script>

<style lang="scss" scoped>
  @use '@/assets/_css/file.scss';


.subscription[class] {
    display: flex;
    flex-direction: column;
    width: fit-content;
    margin-top: 10px;
}

.input-wrapper {
    :deep(div label) {
        color: black;
    }
}
.actions {
    margin-top: 20px;
    display: flex;
    gap: 10px;
}
.action-block {
    display: flex;
    flex-direction: column;
    width: 200px;
    padding: 15px;
    box-sizing: border-box;
    gap: 20px;
    background: #d1d1d1;
    border-radius: 12px;
    button {
        padding: 5px 0;
        width: 100%;
    }
    input {
        background: white;
        color: black;
        border-radius: 3px;
        padding: 5px;
        caret-color: black;
    }
}
.top-section {
    max-width: 1350px;
    margin: auto;
    padding-top: 40px;
}
.home {
    width: 600px;
    display: flex;
    padding: 20px 0;
    flex-direction: column;
    align-items: flex-start;
    justify-content: start;
  }
  
  .date {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    &:deep(input){
      width: 70%;
      margin-right: 5px;
    }
  
  }
  .input-holder {
    display: flex;
    align-items: center;
  
  }
  .user-info {
    display: flex;
    text-align: left;
    flex-direction: column;
  }
  .button-holder {
    width: 150px;
    height: 40px;
  
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    margin-left: auto;
    button {
      height: 40px;
  
    }
  }
  
  .input-section {
    box-sizing: border-box;
  }
  .input-wrapper {
    flex: 1;  
  }
 
  .row {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    
  }

  
  .section-header {
    color: black;
    font-size: 24px;
    text-align: left;
    font-weight: bold;
    margin: 20px 0;
  }
  .error {
    margin-top: -10px;
    margin-bottom: 10px;
    color: red;
  }
  .text {
    color: white;
    margin-right: 5px;
  }


  .breadcrumbs {
    padding-left: 0;
  }
  .invoice-preview {
    background: white;
    box-sizing: border-box;
    border: 1px solid var(--border-color);
    border-radius: 10px;
  }

  .invoice-inputs {
    padding: 20px;
    background: white;
    border-radius: 10px;
    border: 1px solid var(--border-color);  
  }
  .last-month-item {
    cursor: pointer;
    color: rgb(74, 74, 74);
    &:hover {
        color: rgb(97, 97, 97);
    }
}

.html-preview {
    &:deep(*) {
        font-size: 12px;   
    }
    &:deep(p) {
        margin: 3px 0;
    }
    &:deep(.container-invoice){
        width: 700px;
    }
}
.pending-agreement {
    border-radius: 10px;
    border: 1px solid var(--border-color);
    padding: 5px 10px;
    background-color: white;
    box-sizing: border-box;
}

</style>